/** @prettier */

import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import Spinner from '@surfline/quiver-react/dist/Spinner';
import { motion } from 'framer-motion';

import { spinnerVariant, containerVariants } from './variants';
import CollectionCategory from '../CollectionCategory';
import { animationControlsPropType } from '../../propTypes/animation';
import {
  getCollectionTypes,
  getCollections,
  getCollectionsLoading,
} from '../../selectors/multiCam';
import { createCollectionCategories } from './createCollectionCategories';

const CollectionList = React.memo(({ spinnerControls, leftRailControls }) => {
  const collections = useSelector(getCollections);
  const collectionTypes = useSelector(getCollectionTypes);
  const collectionsLoading = useSelector(getCollectionsLoading);

  // Memoize this value so that we don't need to perform the sort and map if props don't change
  const collectionCategories = useMemo(createCollectionCategories(collectionTypes, collections), [
    collectionTypes,
    collections,
  ]);

  return (
    <>
      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate={leftRailControls}
        className="sl-collection-selector"
      >
        {!collectionsLoading &&
          collectionCategories.map(category => (
            <CollectionCategory key={category.name} rank={category.rank} category={category} />
          ))}
      </motion.div>
      <motion.div
        className="sl-multi-cam-spinner"
        variants={spinnerVariant}
        initial="initial"
        animate={spinnerControls}
      >
        <Spinner />
      </motion.div>
    </>
  );
});

CollectionList.propTypes = {
  spinnerControls: animationControlsPropType.isRequired,
  leftRailControls: animationControlsPropType.isRequired,
};

CollectionList.defaultProps = {};

export default CollectionList;
